import { createBrowserHistory } from 'history';

const history = createBrowserHistory({
  basename: '/myev/',
});

export default history;
